/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ChargeIdEnum } from './chargeIdEnum';
import { SkuTypeEnum } from './skuTypeEnum';
import { SkuInfoStatusEnum } from './skuInfoStatusEnum';


export interface SkuInfoPostSpec { 
    charge_id?: ChargeIdEnum;
    datacenter?: string;
    sku: string;
    sku_type: SkuTypeEnum;
    status: SkuInfoStatusEnum;
    multiplier?: number;
}
export namespace SkuInfoPostSpec {
}


